import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import TreatmentEdit from '../../../features/Treatments/TreatmentEdit';
import {
  getTreatment,
  updateTreatment,
  discardTreatment,
  getPatient,
  getFutureAssignedInstancesForTreatment,
  getReferral,
  getSettings,
} from '../../../actions/entities';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import {
  ENABLE_RECORDING_OF_WEEKLY_REQUESTED_DAYS,
  ENABLE_MAPPING_OF_TEAMS,
} from '../../../settings/constants/appSettings';

let hasReferral = null;

const mapStateToProps = ({
  entities: { treatments, patients, referrals, settings },
  uiElements: { selectors },
  global: {
    auth: { jwtToken, featureAccessList, externalProviderType },
  },
}) => {
  const { isFetching: isFetchingTreatment, treatment, futureInstances, hasCompletedVisitToday } = treatments.previewed;
  const { isFetching: referralFetching, referral } = referrals.previewed;
  hasReferral = referral;

  return {
    isFetchingTreatment,
    referralFetching,
    futureInstances,
    treatment,
    patient: patients.previewed.patient,
    activities: selectors.activities && selectors.activities.options,
    referral,
    hasCompletedVisitToday,
    jwtToken,
    enableIntegrationMode: checkFeatureAccess(
      featureAccessList,
      globals.applicationFeatureAccesses.enableIntegrationMode,
    ),
    externalProviderType,
    enableRecordingOfWeeklyRequestedDays: settings.appSettings[ENABLE_RECORDING_OF_WEEKLY_REQUESTED_DAYS] === 'true',
    enableMappingOfTeams: settings.appSettings[ENABLE_MAPPING_OF_TEAMS] === 'true',
  };
};

const mapDispatchToProps = dispatch => ({
  navigate: url => dispatch(push(url)),
  goBack: () => dispatch(goBack()),
  getTreatmentData: async id => {
    let result;
    try {
      result = await dispatch(getTreatment(id));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('errorTreatmentPage', error);
    }
    if (result && result.response.status === 200) {
      await dispatch(getPatient(result.response.data.treatment.patientId));
      if (!hasReferral) {
        await dispatch(getReferral(result.response.data.treatment.referralId));
      }
    }
  },
  editTreatment: treatmentData => dispatch(updateTreatment(treatmentData)),
  discardTreatment: treatmentData => dispatch(discardTreatment(treatmentData)),
  getFutureInstances: treatmentId => dispatch(getFutureAssignedInstancesForTreatment(treatmentId)),
  getSettings: settingName => dispatch(getSettings(settingName)),
});

const TreatmentEditPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TreatmentEdit);

export default TreatmentEditPage;
